export default {
    empresas: [],
    empresa: {}
}